/**
 * Created by fengc on 2020/03/16.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { StyleSheet, View, TouchableWithoutFeedback, Platform } from "react-native";
import { Text } from "native-base";
import Syllable from "./Syllable";
import * as Helper from "../../utils/Helper";
import LetterStateManager from "../../utils/LetterStateManager";

class Letter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changedStated: false,
        };
    }

    componentDidMount() {
        LetterStateManager.instance().updateViewed(this.props.data.char);

        LetterStateManager.instance().events.on("updatedState", this.changedStated);
    }

    componentWillUnmount() {
        LetterStateManager.instance().events.off("updatedState", this.changedStated);
    }

    changedStated = () => {
        this.setState({changedStated: true});
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data && this.props.data) {
            if (prevProps.data.char !== this.props.data.char) {
                LetterStateManager.instance().updateViewed(this.props.data.char);
            }
        }
    }

    render() {
        let containerStyle = [styles.container];
        if (this.props.style) {
            containerStyle.push(this.props.style);
        }

        let contentStyle = [styles.content];

        let letterStyle = _.cloneDeep(styles.letter);
        let pinyinStyle = _.cloneDeep(styles.pinyin);
        if (this.props.style) {
            for (var key in this.props.style) {
                //note that || key === "textDecorationLine" is not look good since every char has a space
                //we will just add border for the word to handle this case
                if (!(key === "color" || key.indexOf("font") !== -1 || key === "lineHeight")) {
                    continue;
                }
                letterStyle[key] = this.props.style[key];
                pinyinStyle[key] = key === "fontSize" ? this.props.style[key] * 0.618 : this.props.style[key];
            }
            // const { fontSize } = this.props.style;
            // letterStyle = [{ ...styles.letter, fontSize: fontSize }];
            // pinyinStyle = [{ ...styles.pinyin, fontSize: fontSize * 0.618 }];
        }

        const letterState = LetterStateManager.instance().letterState(this.props.data.char);
        const letterColor = this.props.enableLearnedColor || this.state.changedStated ? LetterStateManager.instance().letterColor(this.props.data.char) : null;
        if (letterColor) {
            letterStyle.color = letterColor;
        }

        const hidePinYin = this.props.enableLearnedPinyin ? (letterState >= LetterStateManager.StatePassed) : false;
        return (
            <TouchableWithoutFeedback onPress={this._handlePress.bind(this)}>
                <View style={containerStyle}>
                    {this.props.pinyinVisible ? ( // need test
                        <View style={contentStyle}>
                            <Syllable style={[pinyinStyle, this.props.syllableStyle]} data={(!Helper.isPunctuation(this.props.data.char) || this.props.forceLetterShowPinYinForEmptyChar) && (!hidePinYin) ? this.props.data.pinyin : " "} />
                        </View>
                    ) : null}
                    {this.props.charVisible ? (
                        <View style={contentStyle}>
                            <Text allowFontScaling={true} style={[letterStyle]}>{this.props.data.char}</Text>
                        </View>
                    ) : null}
                </View>
            </TouchableWithoutFeedback>
        );
    }
    _handlePress = () => {
        if (this.props.onPress) {
            this.props.onPress(this.props.data);
        }
    };
}

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
    },
    content: { marginHorizontal: 1 },
    pinyin: {
        fontSize: 9.888,
        textAlign: "center",
        //marginBottom: -3,  //拼音往下面点
        //paddingTop:6,
    },
    letter: {
        fontSize: 17,
        color: "#242424",
        //letterSpacing: 0.1,
        //lineHeight: 17,
        //marginTop: 6,
        //paddingTop:8,
        //marginVertical: Platform.OS === "ios" ? 0 : 6,    //将组句题下面的间距放到了每个小框中，添加了paddingBottom
    },
});

Letter.propTypes = {
    data: PropTypes.object,
    style: PropTypes.object,
    syllableStyle: PropTypes.object,
    onPress: PropTypes.func,
    charVisible: PropTypes.bool,
    pinyinVisible: PropTypes.bool,
    enableLearnedColor: PropTypes.bool, //学习过的字是否变色
    enableLearnedPinyin: PropTypes.bool, //是否根据学习过字的等级来判断是否显示拼音
};

Letter.defaultProps = {
    data: {
        pinyin: "",
        char: "",
    },
    style: {}, // this one will be applied on container style
    onPress: null,
    charVisible: true, // if show Chinese character
    pinyinVisible: true, // if show piyin of chinese character
    enableLearnedColor: true, //学习过的字是否变色
    enableLearnedPinyin: true, //是否根据学习过字的等级来判断是否显示拼音
};

export default Letter;
